import { Footprints, LogIn, Percent, Users } from 'lucide-react';
import { SummaryCard } from '@/pages/Dashboard';
import type { NavTotals } from '@/types/navigation-report';
import { fmtNav } from './format';

interface EntriesCardsProps {
    totals: NavTotals;
    periodLabel: string;
}

/** 4 cards da lista — somam só as entradas LISTADAS (top N por sessões). */
export function EntriesCards({ totals, periodLabel }: EntriesCardsProps) {
    return (
        <div className="grid grid-cols-2 gap-px overflow-hidden rounded-lg border border-border bg-border md:grid-cols-4">
            <SummaryCard flush period={periodLabel} title="Sessões" value={fmtNav.num(totals.sessions)} icon={LogIn} iconColor="text-emerald-500" accent="border-t-emerald-500/50" subtitle="entradas listadas" />
            <SummaryCard flush period={periodLabel} title="Visitantes" value={fmtNav.num(totals.visitors)} icon={Users} iconColor="text-violet-500" accent="border-t-violet-500/50" subtitle="únicos por entrada" />
            <SummaryCard flush period={periodLabel} title="Avançaram" value={fmtNav.num(totals.advanced)} icon={Footprints} iconColor="text-blue-500" accent="border-t-blue-500/50" subtitle="viram uma 2ª página" />
            <SummaryCard flush period={periodLabel} title="Taxa de avanço" value={fmtNav.pct1(totals.advance_rate_pct)} icon={Percent} iconColor="text-amber-500" accent="border-t-amber-500/50" subtitle="avançaram / sessões" />
        </div>
    );
}
